import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCentrifugeSkimmer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 110,
	height: 100,
	viewBox: "0 0 110.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 0,
			width: 100,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 100.0 10.0 L 20.0 10.0 L 20.0 90.0 L 100.0 90.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 50.0 L 20.0 50.0 M 20.0 10.0 L 20.0 90.0 M 80.0 20.0 L 60.0 20.0 L 60.0 10.0 L 70.0 20.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		})
	]
});
export default SvgCentrifugeSkimmer;
